import { useState, useEffect } from 'react';
import { Box, FormHelperText } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
} from '../../../common/components';

const FeeStructureDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const [formData, setFormData] = useState({
    name: '',
    fixed_amount: '',
    rate: '',
    iva: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData({
        name: selectedItem?.name || '',
        fixed_amount:
          selectedItem?.fixed_amount !== undefined ? selectedItem.fixed_amount.toString() : '',
        rate: selectedItem?.rate !== undefined ? selectedItem.rate.toString() : '',
        iva: selectedItem?.iva !== undefined ? selectedItem.iva.toString() : '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = true;
    }
    if (!formData.fixed_amount) {
      newErrors.fixed_amount = true;
    }
    if (!formData.rate) {
      newErrors.rate = true;
    }
    if (!formData.iva) {
      newErrors.iva = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <DialogContainer
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { minWidth: '600px', maxWidth: '600px' },
      }}
    >
      <DialogTitle>
        {editMode ? `Editar Estructura de Cuota "${formData.name}"` : 'Nueva Estructura de Cuota'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="name"
              label="Item"
              type="text"
              fullWidth
              value={formData.name}
              onChange={handleInputChange}
              error={errors.name || (saveAttempted && !formData.name)}
            />
            {(errors.name || (saveAttempted && !formData.name)) && (
              <FormHelperText error>Debes ingresar un item.</FormHelperText>
            )}

            <CustomTextField
              margin="dense"
              name="fixed_amount"
              label="Monto Fijo (%)"
              type="text"
              fullWidth
              value={formData.fixed_amount}
              onChange={handleInputChange}
              error={errors.fixed_amount || (saveAttempted && !formData.fixed_amount)}
            />
            {(errors.fixed_amount || (saveAttempted && !formData.fixed_amount)) && (
              <FormHelperText error>Debes ingresar un monto fijo.</FormHelperText>
            )}

            <CustomTextField
              margin="dense"
              name="rate"
              label="Porcentaje (%)"
              type="text"
              fullWidth
              value={formData.rate}
              onChange={handleInputChange}
              error={errors.rate || (saveAttempted && !formData.rate)}
            />
            {(errors.rate || (saveAttempted && !formData.rate)) && (
              <FormHelperText error>Debes ingresar un porcentaje.</FormHelperText>
            )}

            <CustomTextField
              margin="dense"
              name="iva"
              label="IVA (%)"
              type="text"
              fullWidth
              value={formData.iva}
              onChange={handleInputChange}
              error={errors.iva || (saveAttempted && !formData.iva)}
            />
            {(errors.iva || (saveAttempted && !formData.iva)) && (
              <FormHelperText error>Debes ingresar un IVA.</FormHelperText>
            )}
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default FeeStructureDialog;
